import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class ConfigurationinfodataApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'configurationinfodata'
    }


    /**
     * 查询项目列表
     * @returns 
     */
    public getInfoByBId(businessKey){
        return this.send({businessKey: businessKey},"getInfoByBId",Methods.GET)
    }



   
}